<template>
  <div class="modal fade" :class="theme" :id="id" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" :class="`modal-${size}`" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="d-flex justify-content-between">
            <p v-if="title" class="modal-title font-weight-bold mb-1">{{ title }}</p>
            <button type="button" class="close" data-dismiss="modal" :aria-label="$t('message.tooltip.close')">
              <img width="18px" :src="require('@/assets/times.svg')" :alt="$t('message.tooltip.close')" />
            </button>
          </div>
          <slot></slot>
          <p v-if="body" class="tooltip-body" v-html-safe="body"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolTip',
  props: {
    title: {
      type: String,
    },
    id: {
      type: String,
      default: 'tooltip',
    },
    body: {
      type: String,
    },
    theme: {
      type: String,
      default: 'dark',
    },
    size: {
      type: String,
      default: 'md',
      validator: size => ['sm', 'md', 'lg'].indexOf(size) > -1,
    },
  },
};
</script>

<style lang="scss" scoped>
.dark {
  p {
    color: white;
  }
  .modal-content {
    background-color: #4b5863;
  }
  .close {
    img {
      filter: invert(100%);
    }
  }
}
.light {
  .modal-content {
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.12);
    border-radius: 20px;
    border: none;
  }
}
p {
  font-size: 14px;
  margin: 0;
}
.modal-body {
  padding: 20px 20px 24px 20px;
}
.close {
  position: absolute;
  right: 18px;
  top: 13px;
}
</style>
